<template>
  <div>
    <!-- Dialog Inserir contracheque -->
    <v-dialog v-if="selectedEmployee !== ''" v-model="dialog" max-width="470px" class="">
      <v-card class="pb-6">
        <v-app-bar dark dense color="red lighten-1" elevation="0">
          <v-toolbar-title>Cadastrar Contracheque</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon text>
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </v-app-bar>
        <form enctype="multipart/form-data" @submit.prevent="submitCheck()">
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <v-alert
                    text
                    outlined
                    class="py-2 px-1"
                    dark--text
                    color="orange"
                    icon="mdi-alert-box"
                  >
                    Selecione o contracheque correto do funcionário
                  </v-alert>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 text-center">Funcionário</p>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" color="red lighten-1" class="mt-0 pt-0">
                  <p style="font-size: 22px" class="text-center">
                    {{ employees[selectedEmployee].full_name }}
                  </p>
                </v-col>
                <v-col cols="12" sm="12" md="7" lg="7" class="m-0 p-0 mx-auto">
                  <v-select
                    v-model="$v.form.month.$model"
                    :items="months_of_the_year"
                    item-value="id"
                    item-text="name"
                    label="Mês de Referência"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.month"
                    @change="errorMensage('month')"
                    @blur="errorMensage('month')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="5" class="m-0 p-0 mx-auto">
                  <v-select
                    v-model="$v.form.year.$model"
                    :items="listYears"
                    label="Ano"
                    outlined
                    dense
                    class="mx-2"
                    single-line
                    :error-messages="errors.data.year"
                    @change="errorMensage('year')"
                    @blur="errorMensage('year')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" class="m-0 p-0">
                  <v-file-input
                    v-model="$v.form.doc.$model"
                    show-size
                    :rules="rules"
                    accept="application/pdf"
                    placeholder="Selecione um documento PDF"
                    prepend-icon="mdi-file-pdf"
                    label="Contracheque"
                    hide-details="auto"
                    :error-messages="errors.data.doc"
                    @change="errorMensage('doc')"
                    @blur="errorMensage('doc')"
                  ></v-file-input>
                </v-col>
                <input type="hidden" name="employee_id" :value="employees[selectedEmployee].id" />
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 my-0 d-flex justify-space-between">
            <!-- <v-btn color="dark darken-1" text @click="dialog = false">Sair</v-btn> -->
            <v-btn dark small type="submit" color="light-green darken-1" elevation="0">
              Inserir Contracheque
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-row>
      <v-snackbar v-model="snackbar" right top absolute color="white green--text text--darken-4">
        <v-icon small color="green darken-4" class="mr-3">mdi-download</v-icon>
        {{ text }}
        <v-btn color="green darken-4 green--text text--darken-4" text @click="snackbar = false">
          <v-icon small color="green darken-4 green--text text--darken-4">mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-snackbar
        v-model="snackbarUpload"
        right
        top
        absolute
        color="white green--text text--darken-4"
      >
        <v-icon small color="green darken-4" class="mr-3">mdi-upload</v-icon>
        {{ textUpload }}
        <v-btn
          color="green darken-4 green--text text--darken-4"
          text
          @click="snackbarUpload = false"
        >
          <v-icon small color="green darken-4 green--text text--darken-4">mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
        <v-card max-width="100%" outlined>
          <v-card-actions class="mt-1 mx-2 pb-0 mb-0 d-flex justify-end">
            <FormMultiPaycheks />
          </v-card-actions>
          <v-card-title class="pt-0">
            Contracheque dos Funcionários
            <v-row class="px-4">
              <v-text-field
                v-model="Pesquisar"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                class="mx-2"
              ></v-text-field>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="employees"
            :search="Pesquisar"
            class="elevation-3"
          >
            <template v-slot:[`item.mobile_phone`]="{ item }">
              <tr>
                {{
                  '(' + item.mobile_phone.substr(0, 2) + ')' + item.mobile_phone.substr(2, 9)
                }}
              </tr>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-card max-width="100%" flat light>
                <v-card-actions class="m-0 p-0 d-flex justify-center">
                  <!-- <FormCreateEmployee /> -->
                  <template>
                    <v-btn
                      small
                      icon
                      color="blue lighten-1"
                      elevation="0"
                      class="m-0 p-0"
                      @click="selectEmployee(employees.indexOf(item))"
                    >
                      <v-icon dark dense medium class="m-0 p-0">mdi-cloud-upload</v-icon>
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
        <v-card max-width="100%" outlined>
          <v-toolbar short color="green lighten-4" dense dark elevation="0" class="m-0 p-0">
            <v-toolbar-title class="m-0 pt-4">
              <p class="subtitle-2 text-center black--text font-weight-normal">
                <v-icon class="mx-2" color="black lighten">mdi-account-details</v-icon>
                Últimos Contracheques inseridos
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-title class="py-0">
            <v-row>
              <v-col class="pa-0 ma-0" cols="12" lg="6" md="6" sm="6">
                <v-select
                  v-model="search.month"
                  :items="months_of_the_year"
                  label="Mes"
                  item-value="name"
                  item-text="name"
                  class="mx-2"
                  single-line
                >
                </v-select>
              </v-col>
              <v-col class="pa-0 ma-0" cols="12" lg="6" md="6" sm="6">
                <v-select
                  v-model="search.year"
                  :items="listYears"
                  label="Ano"
                  class="mx-2"
                  single-line
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="headerspaycheck"
            :items="paychecks"
            :custom-filter="filterPaychecks"
            :search="search.month || search.year"
            class="elevation-3"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                icon
                color="green"
                class="m-0 p-0"
                dark
                elevation="0"
                @click="dowloadPaycheck(item.id)"
              >
                <v-icon dark medium class="m-0 px-0">mdi-cloud-download</v-icon>
              </v-btn>
              <v-btn small text icon color="red darken-2" class="mx-0 px-0" dark elevation="0">
                <v-icon dark medium tile class="mx-0 px-0">mdi-trash-can</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions, mapState } from 'vuex'
import FormMultiPaycheks from './components/FormMultiPaychecks'

export default {
  name: 'TableUser',
  components: { FormMultiPaycheks },
  data: function () {
    return {
      search: {
        month: '',
        year: '',
      },
      currentYear: new Date().getFullYear(),
      selectedEmployee: '',
      snackbarUpload: false,
      textUpload: '',
      snackbar: false,
      text: '',
      rules: [(value) => !value || value.size < 1000000 || 'Aquivo deve ser menor de que 1 Mega'],
      Pesquisar: '',
      dialog: false,
      headers: [
        {
          text: 'Nome do Funcionário',
          align: 'start',
          sortable: false,
          value: 'full_name',
        },
        { text: 'Setor', value: 'department_name' },
        { text: 'Cargo', value: 'role_name' },
        { text: 'Telefone', value: 'mobile_phone' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      headerspaycheck: [
        {
          text: 'Nome do Funcionário',
          align: 'start',
          sortable: false,
          value: 'full_name',
        },
        { text: 'Mês', value: 'month' },
        { text: 'Ano', value: 'year' },
        { text: 'Data', value: 'created_at' },
        { text: '', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      errors: {
        mensages: { required: 'O campo e obrigatorio' },
        data: { month: [], doc: [] },
      },
      form: {
        doc: [],
        month: '',
        year: '',
      },
    }
  },
  computed: {
    ...mapGetters('employees', ['GET_employees']),
    ...mapGetters('utils', ['GET_monthsOfTheYear', 'GET_employeePaycheck']),
    ...mapState('utils', ['months_of_the_year']),
    ...mapState('employees', ['paychecks', 'employees']),
    listYears() {
      let initialYear = this.currentYear - 2
      const listYears = []

      for (let i = 0; i <= 1; i++) {
        let year = initialYear + i
        listYears.push(year.toString())
      }
      listYears.push(this.currentYear.toString())

      return listYears
    },
  },
  validations: {
    form: {
      month: {
        required,
      },
      doc: {
        required,
      },
      year: {
        required,
      },
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.form.doc = []
        this.form.month = ''
      }
    },
  },
  methods: {
    ...mapActions('employees', [
      'ActionStorePaycheckEmployee',
      'ActionGetPaycheckEmployee',
      'ActionDeletePaycheckEmployee',
    ]),
    ...mapActions('ui', ['ActionSetLoading']),
    selectEmployee(id) {
      this.selectedEmployee = id
      this.dialog = true
    },
    dowloadPaycheck: function (paycheck_id) {
      const data = { paycheck_id }
      try {
        const name = this.paychecks.find((pay) => pay.id === paycheck_id)
        this.$http
          .post('dash/employees/paycheck/download', data, {
            responseType: 'arraybuffer',
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', name.paycheck) //or any other extension
            document.body.appendChild(link)
            link.click()
            this.text = 'Download realizado com sucesso!'
            this.snackbar = true
          })
      } catch (error) {}
    },
    deletePaycheck: async function (paycheck_id) {
      try {
        this.$swal({
          icon: 'warning',
          title: 'Deletar',
          text: 'Deseja realmente deletar?',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            this.ActionSetLoading(true)
            await this.ActionDeletePaycheckEmployee(paycheck_id)
            this.ActionSetLoading(false)
            this.$swal({
              icon: 'success',
              title: 'Deletado',
              text: 'Contracheque deletado com sucesso',
            })
          }
        })
      } catch (error) {}
    },
    close() {
      this.dialog = false
    },
    uploadPaycheck: async function () {
      try {
        console.log(this.form.year)
        this.ActionSetLoading(true)
        let employee_id = this.employees[this.selectedEmployee].id
        let paycheck = new FormData()
        paycheck.append('files', this.form.doc, this.form.doc.name)
        paycheck.append('employee_id', employee_id)
        paycheck.append('months_of_the_year_id', this.form.month)
        paycheck.append('year', this.form.year)
        console.log(paycheck)
        await this.ActionStorePaycheckEmployee(paycheck)
        this.ActionSetLoading(false)
        this.$swal({
          icon: 'success',
          title: 'Cadastrado',
          text: 'Contracheque cadastrado com sucesso!',
        })
        this.textUpload = 'Contracheque cadastrado com sucesso!'
        this.dialog = false
      } catch (error) {
        if (error.body) {
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: error.body.message,
          })
        }
      }
      this.ActionSetLoading(false)
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.mensages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.mensages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.mensages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.mensages.email)

      this.errors.data[key] = errors
    },
    submitCheck: async function () {
      this.ActionSetLoading(true)
      try {
        this.$v.$touch()
        Object.keys(this.form).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          this.uploadPaycheck()
        } else {
          this.ActionSetLoading(false)
        }
      } catch (error) {
        this.ActionSetLoading(false)
      }
    },
    filterPaychecks(value, search, item) {
      return (
        (this.search.month !== '' ? item.month == this.search.month : true) &&
        (this.search.year !== '' ? item.year == this.search.year : true)
      )
    },
  },
}
</script>
